import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonGroup } from '@mui/material';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language;

  return (
    <ButtonGroup variant="text" size="small" sx={{ ml: 1, mr: 1 }}>
      <Button
        color="inherit"
        sx={current === 'ru' ? { fontWeight: 'bold', textDecoration: 'underline' } : {}}
        onClick={() => i18n.changeLanguage('ru')}
      >
        RU
      </Button>
      <Button
        color="inherit"
        sx={current === 'mn' ? { fontWeight: 'bold', textDecoration: 'underline' } : {}}
        onClick={() => i18n.changeLanguage('mn')}
      >
        MN
      </Button>
      <Button
        color="inherit"
        sx={current === 'en' ? { fontWeight: 'bold', textDecoration: 'underline' } : {}}
        onClick={() => i18n.changeLanguage('en')}
      >
        EN
      </Button>
    </ButtonGroup>
  );
}